module.exports = __webpack_public_path__ + "static/media/lb-add.803ff92a.svg";